import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; 
import { BrokerServices } from '../../services/BrokerServices';
import { ResetPasswordService } from '../../services/ResetPasswordService';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import From from '../components/From';
import MasterDropdown from '../components/MasterDropdown';
import To from '../components/To';

function Broker() {
  const navigate = useNavigate(); 

  const [loading, setLoading] = useState(false);
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [brokerlist, setBrokerlist] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null); 
  const [fromDate, setFromDate] = useState(''); 
  const [toDate, setToDate] = useState('');

  var user = BullCache.getFromCache("user");
  useEffect(() => {
    getBrokers();
  }, []);

  function getBrokers(){

    setLoading(true);      
    var broker1 = {};
    if ((selectedAdmin === null || !selectedAdmin.value) && (selectedMaster === null || !selectedMaster.value)) {
      broker1 = { adminId: user.adminId };
    } else { 
      if (selectedMaster != null && selectedMaster) {
        broker1 = { adminId: selectedMaster.value }
      } else if (selectedAdmin != null && selectedAdmin) {
        broker1 = { adminId: selectedAdmin.value }
      }
    }

    BrokerServices.getBroker(broker1).then(resp => {
      setLoading(false);       
        if (resp.code === 1) {
          if (resp.data.brokerList.length > 0) {
            setBrokerlist(resp.data.brokerList);
          } else {
            setBrokerlist([]);
          }
        }
      });
  }

  const handleSubmit = () => {
    getBrokers();
  }

  const handleSelectedMasterChange = (selectedOption) => {
    setSelectedMaster(selectedOption);
  };

  const handleSelectedAdminChange = (selectedOption) => {
    setSelectedAdmin(selectedOption);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate); 
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };
  const handleNavigate = (event) => {
    const rowId = event.target.getAttribute("row-id");  
    const dataId = event.target.getAttribute("data-id");  

    navigate("/editAccount", { state: { rowId, adminIdMaster: dataId } });

  };
 const handlePasswordReset = (dataId) => {
        // Call the API to reset the password
        Swal.fire({
            title: "Are you sure?",
            text: "You are about to reset the password for this user.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, reset it!",
            cancelButtonText: "No, cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                const resetPayload = {
                    adminId: dataId,
                    loginId: user.adminId  // Include loginId along with adminId in the request
                };
                // If user clicks "Yes", proceed with password reset
                ResetPasswordService.resetPassword(resetPayload).then(resp => {
                    if (resp.code === 1) {
                        const userName = resp.data.userName;
                        const password = resp.data.password;
                        Swal.fire({
                          title: "Success!",
                          html: `Password reset successfully.<br> UserName: <b> ${userName} </b> <br> Password: <b> ${password} </b>`,
                          icon: "success",
                          confirmButtonText: "Okay",
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: resp.messages,
                            icon: "error"
                        });
                    }
                }).catch((error) => {
                    Swal.fire({
                        title: "Error",
                        text:  error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
                        icon: "error"
                    });
                });
            } else {
                // If user clicks "No", do nothing
                Swal.fire({
                    title: "Cancelled",
                    text: "Password reset was cancelled.",
                    icon: "info"
                });
            }
        });
    };

    const handleClick = (event) => {
      if (event.target.classList.contains("table-btn")) {
          const buttonType = event.target.textContent.trim();
          const dataId = event.target.getAttribute("data-id");
  
          if (buttonType === "RP") {
              handlePasswordReset(dataId);
          }
          else if (buttonType === "A") {
              handleUserStatusChange(dataId, "DEACTIVE"); // Passing "DEACTIVE" status
          }
          else if (buttonType === "D") {
              handleUserStatusChange(dataId, "ACTIVE"); // Passing "ACTIVE" status
          } else {
              handleNavigate(event);
          }
      }
  };
  
  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

 const handleUserStatusChange = (dataId, status) => {
           const action = status === "ACTIVE" ? "Activate" : "Deactivate";
           Swal.fire({
               title: `Are you sure?`,
               text: `You are about to ${action} this user.`,
               icon: "warning",
               showCancelButton: true,
               confirmButtonText: `Yes, ${action} it!`,
               cancelButtonText: "No, cancel"
           }).then((result) => {
               if (result.isConfirmed) {
                   const statusPayload = {
                       adminId: dataId,
                       loginId: user.adminId,  // Include loginId along with adminId in the request
                       status: status
                   };
       
                   BrokerServices.changeStatus(statusPayload).then(resp => {
                       if (resp.code === 1) {
                           Swal.fire({
                               title: "Success",
                               text: `User ${action}d successfully!`,
                               icon: "success"
                           });
                           getBrokers();
                       } else {
                           Swal.fire({
                               title: "Error",
                               text: resp.messages,
                               icon: "error"
                           });
                       }
                   }).catch((error) => {
                       Swal.fire({
                           title: "Error",
                           text:  error?.response?.data?.data?.errors[0]?.errorMessage || "Netwrok error!",
                           icon: "error"
                       });
                   });
               } 
           });
       };

  const columns = [
    {
      title: 'NAME', className: 'col-2 font-bold text-nowrap', render: (data, type, full, meta) => {
        return full.firstName + ' ' + full.lastName
      }
    },
    { title: 'LOGIN ID', data: 'userName', className: 'col-1 font-bold text-nowrap' },
    { title: 'MASTER', render: (data, type, full, meta) => full.parentAdminId.userName, className: 'col-1 font-bold text-nowrap' },
    { title: 'PERCENTAGE', data: 'parentPercentage', className: 'col-1 font-bold text-nowrap' },
    { title: 'CLIENT COUNT', data: 'brokerCount', className: 'col-1 font-bold text-nowrap' },
    {
      title: 'ACTION', data: 'status', className: 'col-2 font-bold text-center text-nowrap',
      render: (data, type, row, full, meta) => {
       
        return `
        <button title="Edit Settings"  class="table-btn font-bold fss-1 bg-warning btn-table"  row-id="${full.row}" data-id="${row.adminId}" >E</button>
        <button title="Ledger" class=" font-bold fss-1 bg-danger btn-table "  row-id="${full.row}"  >L</button>
                    <button title="Reset Password" class="table-btn font-bold fss-1 bg-success btn-table" row-id="${full.row}" data-id="${row.adminId}">RP</button>
<button class="font-bold fss-1 table-btn btn-table ${row.status ? 'bg-primary' : 'bg-secondary'}" row-id="${full.row}" data-id="${row.adminId}" title="${row.status ? 'Active' : 'DeActive'}">
${row.status ? 'A' : 'D'}
</button>`;
      },
    },
    { title: 'LOGIN TIME', data: 'lastLogin', className: 'col-1 font-bold text-nowrap' },
    { 
      title: 'LOGIN IP', 
      className: "text-nowrap",
      render: (data, type, full, meta) => {
        const ip = full.loginIp;
        if (!ip) return null; // If there's no IP, return null (nothing to display)
  
        // Create the anchor tag for the IP
        return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
      },
    },{ title: 'JOIN TIME', data: 'createdAt', className: 'col-1 font-bold text-nowrap' },

  ];


  return (
    <div className='mb-5'>
      <Card >
        <Card.Body>
          <Container fluid>
            <Row >
              {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                <>
                  <Col xs={6} sm={2}>
                  <b className="fss-05">ADMIN</b>
                    <AdminDropdown
                      adminId={user.adminId} 
                      selectedAdmin={selectedAdmin}
                      setSelectedOption={setSelectedAdmin} />
                  </Col>
                </> : ""}

              {user.adminType == 'SUPER_ADMIN'  || user.adminType == 'SUPER_MASTER' ?
                <>
                  <Col xs={6} sm={2}>
                  <b className="fss-05">MASTER</b>
                    <MasterDropdown
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      setSelectedOption={setSelectedMaster}
                      setSelectedMaster={setSelectedMaster}
                      setSelectedBrokerId={setSelectedBrokerId}
                    />
                  </Col>
                </> : ""}

                { user.adminType == 'ADMIN' ?
                <>
                  <Col xs={6} sm={2}>
                  <b className="fss-05">MASTER</b>
                    <MasterDropdown
                      adminId={user.adminId}
                      selectedAdmin={selectedAdmin}
                      selectedMaster={selectedMaster}
                      setSelectedOption={setSelectedMaster}
                      setSelectedMaster={setSelectedMaster}
                      setSelectedBrokerId={setSelectedBrokerId}
                    />
                  </Col>
                </> : ""}

              <Col xs={5} sm={2} xl={1} className='me-4'>
                <b className='fss-05'>FROM</b><br />
                <From fromDate={fromDate} onDateChange={handleFromDateChange} /> 
              </Col>
              <Col xs={5} sm={2} xl={1} className='me-4'>
                <b className='fss-05'>TO</b><br />
                <To toDate={toDate} setToDate={setToDate} />
              </Col>


              <Col xs={6} sm={2} className="mt-4">
                <Button variant="success" size="sm w-75" onClick={handleSubmit}>
                  <b className="fss-08">SUBMIT</b>
                </Button>
              </Col>


              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>


          </Container>
        </Card.Body>
      </Card>

      <Card className='mt-3' >
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable id="table" className="mt-1 table table-striped bg-secondary-row fss-09"
                columns={columns} data={brokerlist}
              />
            )}
          </div>

        </Card.Body>
      </Card>
    </div>


  )

}
export default Broker;